import {Drawer, Segmented, Space} from 'antd';
import styled from 'styled-components';
import {typographyStyles} from '../../../../utils/styles';
import {
  StyledContractDetailsFileUploadSpace
} from '../../SubscriptionPage/tabComponents/Overview/ContractDetails/StyledContractDetails';

const StyledAddSingleSubscriptionModal = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    button {
      margin-inline-end: 0;
      margin-inline-start: 12px;
    }
  }
  .ant-drawer-title {
    font-weight: 500;
  }
  .ant-drawer-footer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 16px 24px;
  }

  .d-none-label {
    .ant-form-item-label {
      display: none;
    }
  }
  
  .ant-divider {
    margin-bottom: 12px;
  }
  
  .ant-drawer-body {
    padding: 0;
  }
`;

const StyledAddSingleSubscriptionModalSegmented = styled(Segmented)`
  &.ant-segmented.ant-segmented-lg {
    padding: 4px;
    
    .ant-segmented-item-label {
      ${typographyStyles.heading.h5};
      color: ${props => props.theme.colors.neutral_7};
      line-height: 40px;
      min-height: 40px;
      
      svg {
        color: rgba(0, 0, 0, 0.45);
        height: 14px;
        width: 14px;
      }
    }
    
    .ant-segmented-item-selected {
      .ant-segmented-item-label {
        color: ${props => props.theme.colors.neutral_10};
      }
    }
  }
`;


const StyledAddSingleSubscriptionModalCardInfo = styled(Space)`
  margin-bottom: 24px;
  color: ${props => props.theme.colors.neutral_7};
`;

const StyledAddSingleSubscriptionModalTransitionContainer = styled.div`
  position: relative;
  height: calc(100vh - 57px - 73px);
  overflow-x: hidden;
  overflow-y: auto;
`;

const StyledAddSingleSubscriptionModalStep = styled.div`
  position: absolute;
  padding: 24px;
  width: 100%;
  transition: transform 500ms ease-in-out, opacity 500ms ease-in-out;
  
  /* Step 1 moves left when Step 2 appears */
  &.step1 {
    opacity: 1;
    transform: translateX(0);
    
    &.move-left {
      opacity: 0;
      transform: translateX(-100%);
    }
  }
  
  /* Step 2 is hidden initially */
  &.step2 {
    transform: translateX(100%);
    opacity: 0;
    
    &.move-in {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const StyledAddSingleSubscriptionModalContactFileSpace = styled(StyledContractDetailsFileUploadSpace)`
  .ant-input-affix-wrapper .ant-input-clear-icon-hidden {
    visibility: unset;
  }
`;

export {
  StyledAddSingleSubscriptionModal,
  StyledAddSingleSubscriptionModalSegmented,
  StyledAddSingleSubscriptionModalCardInfo,
  StyledAddSingleSubscriptionModalContactFileSpace,

  StyledAddSingleSubscriptionModalTransitionContainer,
  StyledAddSingleSubscriptionModalStep,
}
